import { safeJsonParse } from "../components/global/JsonHelper";

export class NavigationHistoryService {
  constructor() {
    this.key = "navigationHistory";
    this.init();
  }

  init() {
    if (!sessionStorage.getItem(this.key)) {
      sessionStorage.setItem(
        this.key,
        JSON.stringify({
          "client-detail": "/client-info/images",
        })
      );
    }
  }

  save(section, url) {
    const history = safeJsonParse(sessionStorage.getItem(this.key), {});
    history[section] = url;
    sessionStorage.setItem(this.key, JSON.stringify(history));
  }

  get(section) {
    const history = safeJsonParse(sessionStorage.getItem(this.key), {});
    return history[section] || null;
  }

  delete(section) {
    const history = safeJsonParse(sessionStorage.getItem(this.key), {});
    delete history[section];
    sessionStorage.setItem(this.key, JSON.stringify(history));
  }

  clear() {
    sessionStorage.setItem(this.key, JSON.stringify({}));
  }
}
